import { Icon, IconProps } from "@chakra-ui/react";
import { LuFlag } from "react-icons/lu";

export default function Checkpoint(props: IconProps) {
  return <Icon as={LuFlag} {...props} />;
}
